import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { SIGNUP_FORM_URL } from '../../../../config/links';
import logo from '../../../../assets/icon/logo.svg';
import ui from '../../../../styles/ui.module.css';
import st from './TopNav.module.css';

export function TopNav({ onTop, onProgram, onQuestion }) {
  return (
    <header className={`${ui.nav} ${st.root}`}>
      <div className={`${ui.container} ${ui.navInner}`}>
        <button className={ui.brand} onClick={onTop} type="button">
          <img className={ui.brandLogo} src={logo} alt="" aria-hidden="true" />
        </button>

        <nav className={ui.navLinks} aria-label="Навигация">
          <button className={ui.link} onClick={onProgram} type="button">
            Программа
          </button>
          <button className={ui.link} onClick={onQuestion} type="button">
            Вопрос
          </button>
          <a
            className={`${ui.btn} ${ui.btnGhost}`}
            href={SIGNUP_FORM_URL}
            target="_blank"
            rel="noreferrer"
          >
            Записаться <FontAwesomeIcon icon={faArrowRight} />
          </a>
        </nav>
      </div>
    </header>
  );
}

